import _ from 'lodash';
import WebStoragePolyfill from '../../data-providers/webstorage-polyfill';
import StoreHistory from '../../data-providers/store-history';
import actions from '../../actions/product';
import Analytics from '../../analytics';
import config from 'config';

export default [
  '$rootScope', '$q', '$state', '$stateParams', '$location', '$window', 'OrderService',
  'CampaignService', 'CustomerService', 'CartService', 'CartAPIService', 'ErrorHandler',
  'AuthService', 'UserService', 'UserDataService', 'username', 'campaignSlug', 'CurrencyService', 'AbandonedCartService',
  class ThankYouController {
    constructor($rootScope, $q, $state, $params, $location, $window, orderService,
      campaignService, customerService, cartService, cartAPIService, errorHandler,
      authService, userService, userDataService, username, campaignSlug, CurrencyService, AbandonedCartService,
      webstorage = new WebStoragePolyfill(), storeHistory = new StoreHistory(), analytics = new Analytics()) {
      this._$rootScope = $rootScope;
      this._$q = $q;
      this._$state = $state;
      this._$params = $params;
      this._$location = $location;
      this._$window = $window;
      this._orderService = orderService;
      this._campaignService = campaignService;
      this._customerService = customerService;
      this._cart = cartService;
      this._cartAPIService = cartAPIService;
      this.currency = CurrencyService;
      this._errorHandler = errorHandler;
      this._authService = authService;
      this._userService = userService;
      this._userDataService = userDataService;
      this._username = username;
      this._campaignSlug = campaignSlug;
      this._abandonedCart = AbandonedCartService;
      this._storage = webstorage;
      this._storeHistory = storeHistory;
      this.analytics = analytics;

      this.months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
      this.orderID = $params.order_num;

      this.isNotUpsell = false;
      this.showChangeAddress = false;
      this.phoneSaved = false;
      this.isProcessing = true;
      this.trackingCode = null;

      this.promoOrders = [];
      this.phone = '';

      let numAndZip = this._storage.getLocalItem('order-credentials') || null;
      if ($params.order_num && $params.zip) {
        this.order_num = $params.order_num;
        this.zip = $params.zip;
        // this.password = $params.password;

        this._$params.order_num = null;
        this._$params.zip = null;
      } else if (numAndZip !== null) {
        numAndZip = numAndZip.split(':');
        this.order_num = numAndZip[0];
        this.zip = numAndZip[1];
      }

      this.firstThankYouView = !this._viewedThisThankYou();
      this._initThankYou();

      this.grecaptchaInterval = setInterval(() => {
        if (this._$window.grecaptcha && this._$window.grecaptcha.render) {
          this.recaptchaRegisterId = this._$window.grecaptcha.render('google_recaptcha_ty_register', {
            sitekey: config.GOOGLE_RECAPTCHA_SITEKEY,
            size: 'invisible',
            callback: token => this.quickRegister(token),
          });

          this.recaptchaLoginId = this._$window.grecaptcha.render('google_recaptcha_ty_login', {
            sitekey: config.GOOGLE_RECAPTCHA_SITEKEY,
            size: 'invisible',
            callback: token => this.linkOrder(token),
          });

          clearInterval(this.grecaptchaInterval);

          $('.g-recaptcha-response').attr('aria-label', 'google recaptcha');
          $('.g-recaptcha-response').attr('aria-label', 'google recaptcha');
        }
      }, 100);
    }

    _initThankYou() {
      this.continueUrl = this._storeHistory.getLastStoreUrl();

      if (this.order_num && this.zip) {
        this._getThankYouDetails();
      } else {
        this._$window.location.href = this.continueUrl;
      }
    }

    _getThankYouDetails() {
      let promiseArray = [];

      let fetchOrder = this._orderService.getBaseOrder(this.order_num, this.zip)
        .then((res) => this.initOrder(res))
        .catch(() => this._errorHandler.throwError('Order Error', 'We encountered an error while looking up your order, please try again.'));
      promiseArray.push(fetchOrder);

      let fetchEstimatedDates = this._orderService.getFulfillmentDatesByOrderNumber(this.order_num)
        .then((res) => this.initEstimatedDates(res))
        .catch(() => this._errorHandler.throwError('Order Error:', 'We encountered an error while estimating dates for your order, please try again.'));
      promiseArray.push(fetchEstimatedDates);

      this._$q.all(promiseArray)
        .finally(() => this.isProcessing = false);
    }

    initOrder(res) {
      this.orderObj = res;
      this.order = res.base;
      this.promoOrders = res.upsells;

      if (this.order_num === this.order['order_num']) {
        this.isNotUpsell = true;
      }

      this.customer = this.order['order_customer'];
      this.currency.setCountry(this.customer.address.country);

      if (!this._username || !this._campaignSlug) {
        this._username = this.order.campaign.creator.user_info.public_name;
        this._campaignSlug = this.order.campaign.slug;
      }

      if (this.firstThankYouView) {
        if (!res.upsells.length) {
          this.analytics.thankYou(res.base);
        } else {
          if (this.order.transaction.payment_type === 'PAYPAL') this.analytics.placeOrder({ option: 'PayPal', upsell: true });
          let upsellOrder = _.find(res.upsells, upsell => upsell.order_num === this.order_num);
          this.analytics.thankYou(null, upsellOrder);
        }
      }

      this._abandonedCart.convertTrackedCart(this.customer.email, this.order_num);
      this._cart.init(this._username, this._campaignSlug)
        .then(() => {
          this._cart.setCountry(this.customer.address.country);
          if (this.order.transaction.payment_type === 'PAYPAL' && this.firstThankYouView && !res.upsells.length)
            this.analytics.placeOrder({ option: 'PayPal', cart: this._cart.contentsAsCampaignProducts() });
        });
      this.upsell = {
        country: this.customer.address.country,
        campaignId: this.order.campaign_id,
        paymentMethod: this.order.transaction.payment_type,
        orderId: res.base.order_num
      };
      this._cart.clearCart(`${this._username}/${this._campaignSlug}`);

      this.analyticsOrder = _.find(_.flatten([this.order, this.promoOrders]), (order) => order.order_num == this.order_num) || this.order;

      if (this.order.campaign.cobrand_id) {
        this._$rootScope.$broadcast('partnership:showLogo', {
          pid: this.order.campaign.cobrand_id
        });
      }

      this._viewedThisThankYou(true);
    }

    initEstimatedDates(res) {
      this.estEnd = this._$window.moment(res.dates.campaign_end_date).format('MMM Do');
      this.estPrint = this._$window.moment(res.dates.estimated_print_date).format('MMM Do');
      this.estShip = this._$window.moment(res.dates.estimated_shipping_date).format('MMM Do');
    }

    updatePhone() {
      if (!_.has(this, 'customer.id')) {
        this._errorHandler.throwError('Error Saving Phone', 'An error occurred while trying to save phone number. Please contact support.');
        return;
      }

      this.isProcessing = true;

      this._customerService.updatePhone(this.customer.id, this.phone, this.zip)
        .then((data) => {
          this.customer = data;
          this.phoneSaved = true;
        })
        .catch(() => {
          this._errorHandler.throwError('Error Saving Phone', 'An error occurred while trying to save phone number. Please contact support.');
          this.phoneSaved = false;
        })
        .finally(() => this.isProcessing = false);
    }

    realProductPrice(product) {
      return product.campaign_product.selling_price + product.campaign_product.product.upcharges[product.size];
    }

    print() {
      this._$window.print();
    }

    submitLogin(isValid) {
      if (isValid) this._$window.grecaptcha.execute(this.recaptchaLoginId);
    }

    linkOrder(recaptchaToken) {
      this._$window.grecaptcha.reset(this.recaptchaLoginId);

      this.isProcessing = true;

      this._authService.login(this.customer.email, this.existingPassword, false, recaptchaToken)
        .then((res) => {
          this._userDataService.setUserData(res, true);
          this.existingCustomerLoggedIn = true;
          this.userSlug = res.user.user_info.public_name;
        })
        .then(() => this._userService.linkOrder(this.userSlug, this.order_num, this.customer.email))
        .catch(() => this._errorHandler.throwError('Login Error', 'An error has occurred while trying to log in. Please try again later.'))
        .finally(() => this.isProcessing = false);

    }

    goToSummary() {
      this._$state.go('order-summary', {
        order: this.orderObj
      });
    }

    submitQuickRegister(isValid) {
      if (isValid) this._$window.grecaptcha.execute(this.recaptchaRegisterId);
    }

    quickRegister(recaptchaToken) {
      this._$window.grecaptcha.reset(this.recaptchaRegisterId);

      this.isProcessing = true;
      this._authService.quickRegister(this.order_num, this.password, recaptchaToken)
        .then((res) => {
          this._userDataService.setUserData(res);
          this.existingCustomerLoggedIn = true;
          this.password = null;
          this.userRegistered = true;
        })
        .catch(err => this._errorHandler.throwError('Registration Error', 'We encountered an error while attempting to register your account.', {
          rawError: err
        }))
        .finally(() => this.isProcessing = false);
    }

    sizeDisplay(product) {
      return actions.sizeDisplay(product.campaign_product.product, product.size);
    }

    _viewedThisThankYou(setValue) {
      if (setValue === true) {
        this._storage.setLocalItem(`thank-you:${this.order_num}`, 'true')
      }
      return this._storage.getLocalItem(`thank-you:${this.order_num}`) === 'true';
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/pages/thank-you/thank-you.ctrl.js